import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import "./Accordion.css";
import { ACCORDION_DATA } from "./values";

export default function Accordion({ data, style, className, icons }) {
  const [clickedItem, setClickedItem] = useState(null);

  const toggleClicked = (index) => {
    if (clickedItem !== index) {
      setClickedItem(index);
    } else {
      setClickedItem(null);
    }
  };
  
  return (data || ACCORDION_DATA).map((data, index) => {
    return (
      <div>
        <div
          className={`accordion-toggle ${className} ${
            index === clickedItem && "active-item"
          }`}
          onClick={() => toggleClicked(index)}
          key={index}
          style={style}
        >
          <h3>{data?.title}</h3>
          <div className="elevate-foat accordion-icon">
            {clickedItem === index ? (
              icons ? (
                <FontAwesomeIcon icon={icons[1]} />
              ) : (
                "-"
              )
            ) : icons ? (
              <FontAwesomeIcon icon={icons[0]} />
            ) : (
              "+"
            )}
          </div>
        </div>
        <div>
          {clickedItem === index && (
            <div className="accordion-content">{data?.content}</div>
          )}
        </div>
      </div>
    );
  });
}
